import { FaStar } from "react-icons/fa";

const ReviewBlock = (data: Reviews) => {


    return (
        <div className="review_block"> 
                            
        <h3>{data.fname} {data.lname}</h3>
        <div className="star_rate"> 
            <div className={data.rate >= 1? 'active_star': ''}><FaStar /></div>
            <div className={data.rate >= 2? 'active_star': ''}><FaStar /></div>
            <div className={data.rate >= 3? 'active_star': ''}><FaStar /></div>
            <div className={data.rate >= 4? 'active_star': ''}><FaStar /></div>
            <div className={data.rate >= 5? 'active_star': ''}><FaStar /></div>
        </div>
        <p className="text_nofont">{data.message}</p>
        
    </div>

    );
}

export default ReviewBlock;